module.exports = "/images/graduation-background.png?d604d121bae44a7c472837e54ac27162";